import React from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { genders, documentFieldTypes } from 'presentation/model/constants';

class GeneralTabStudentForm extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        let { form, handleChange, component, countries = [], races = [], localities = [] } = this.props;
        return (
            <Container>
                <Row>
                    <Col>
                        <h4>Informações do aluno</h4>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="name">Nome</Form.Label>
                            <Form.Control
                                type="text"
                                id="name"
                                name="name"
                                defaultValue={form.name}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="nameHelpBlock"
                            />
                            <Form.Text id="nameHelpBlock" muted>
                                Informe o nome do aluno
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="displayName">Nome social</Form.Label>
                            <Form.Control
                                type="text"
                                id="displayName"
                                name="displayName"
                                defaultValue={form.displayName}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="displayNameHelpBlock"
                            />
                            <Form.Text id="displayNameHelpBlock" muted>
                                Escolha um nome de exibição/nome social
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="registration">Matrícula</Form.Label>
                            <Form.Control
                                type="text"
                                id="registration"
                                name="registration"
                                defaultValue={form.registration}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="registrationHelpBlock"
                            />
                            <Form.Text id="registrationHelpBlock" muted>
                                Informe a matrícula
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="registrationDate">Data de matrícula</Form.Label>
                            <Form.Control
                                type="date"
                                id="registrationDate"
                                name="registrationDate"
                                defaultValue={form.registrationDate}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="registrationDateHelpBlock"
                            />
                            <Form.Text id="registrationDateHelpBlock" muted>
                                Informe a data de matrícula (opicional)
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="birthdate">Data de nascimento</Form.Label>
                            <Form.Control
                                type="date"
                                id="birthdate"
                                name="birthdate"
                                defaultValue={form.birthdate}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="birthdateHelpBlock"
                            />
                            <Form.Text id="birthdateHelpBlock" muted>
                                Informe a data de nascimento
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="gender">Sexo</Form.Label>
                            <Form.Select
                                aria-label="Sexo"
                                defaultValue={form.gender}
                                id="gender"
                                name="gender"
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="genderHelpBlock"
                                required
                            >
                                <option key="-1">Selecione</option>
                                {genders.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                            </Form.Select>
                            <Form.Text id="genderHelpBlock" muted>
                                Defina a qual é o sexo biológico
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="documentField">Documento</Form.Label>
                            <Form.Control
                                type="text"
                                id="documentField"
                                name="documentField"
                                defaultValue={form.documentField}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="documentFieldNameHelpBlock"
                            />
                            <Form.Text id="documentFieldNameHelpBlock" muted>
                                Informe um documento válido
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="documentFieldType">Tipo do documento</Form.Label>
                            <Form.Select
                                aria-label="Tipo do documento"
                                defaultValue={form.documentFieldType}
                                id="documentFieldType"
                                name="documentFieldType"
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="documentFieldTypeHelpBlock"
                                required
                            >
                                <option key="-1">Selecione</option>
                                {documentFieldTypes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                            </Form.Select>
                            <Form.Text id="documentFieldTypeHelpBlock" muted>
                                Defina a qual é o tipo do documento informado
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="email">E-mail</Form.Label>
                            <Form.Control
                                type="text"
                                id="email"
                                name="email"
                                defaultValue={form.email}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="emailHelpBlock"
                            />
                            <Form.Text id="emailelpBlock" muted>
                                Informe o e-mail do aluno
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={3}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="localityId">Naturalidade</Form.Label>
                            <Form.Select
                                aria-label="Naturalidade"
                                defaultValue={form.localityId}
                                id="localityId"
                                name="localityId"
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="localityIdHelpBlock"
                                required
                            >
                                <option key="-1">Selecione</option>
                                {localities.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                            </Form.Select>
                            <Form.Text id="localityIdHelpBlock" muted>
                                Defina a qual é a naturalidade
                            </Form.Text>
                        </div></Col>
                    <Col lg={3}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="countryId">Nacionalidade</Form.Label>
                            <Form.Select
                                aria-label="Nacionalidade"
                                defaultValue={form.countryId}
                                id="countryId"
                                name="countryId"
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="countryIdHelpBlock"
                                required
                            >
                                <option key="-1">Selecione</option>
                                {countries.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                            </Form.Select>
                            <Form.Text id="countryIdHelpBlock" muted>
                                Defina a qual é a nacionalidade
                            </Form.Text>
                        </div></Col>
                    <Col lg={3}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="raceId">Raça/Cor</Form.Label>
                            <Form.Select
                                aria-label="Raça/Cor"
                                defaultValue={form.raceId}
                                id="raceId"
                                name="raceId"
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="raceIdHelpBlock"
                                required
                            >
                                <option key="-1">Selecione</option>
                                {races.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                            </Form.Select>
                            <Form.Text id="raceIdHelpBlock" muted>
                                Defina a qual raça/cor
                            </Form.Text>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    };
}

export default GeneralTabStudentForm;